import { getEnvRequired } from '../../shared/utilities/env';
import { ApiClient } from '../shared/api/client';

import { CalendarStatus, ConnectCalendarPayload } from './types';

const AGENCY_NETWORK_MANAGEMENT_API_URL = getEnvRequired('AGENCY_NETWORK_MANAGEMENT_API_URL');

const apiClient = new ApiClient();

export async function getCalendarStatus(): Promise<CalendarStatus> {
    const url = `${AGENCY_NETWORK_MANAGEMENT_API_URL}/appointment-scheduling/calendar/status`;
    return apiClient.get<CalendarStatus>(url);
}

export async function connectCalendar(payload: ConnectCalendarPayload): Promise<void> {
    const url = `${AGENCY_NETWORK_MANAGEMENT_API_URL}/appointment-scheduling/calendar/connect`;
    const body = JSON.stringify(payload);
    const headers = { 'Content-Type': 'application/json' };
    await apiClient.post<unknown>(url, body, headers);
}
